<nav (mousedown)="onNavClick()" (touchstart)="onNavClick()">
    <ul>
        <li *ngFor="let graph of graphs">
            <button class="graph-anchor" (click)="scroll(graph)">
                {{graph}}
            </button>
        </li>
    </ul>
</nav>
